import { WithStyles, withStyles } from '@mui/styles';
import {
    FirmAssetBalanceStatistics,
    FirmRecord
} from '@tassat/fred-definitions';

import { FirmDetailsPanel } from './firmDetailsPanel';
import { muiStyles } from './styles';

export interface FirmDetailsPanelProps extends WithStyles<typeof muiStyles> {
    match: any;
    firm: FirmRecord;
    firmAssetStats: FirmAssetBalanceStatistics[];
}

export default withStyles(muiStyles)(FirmDetailsPanel);